export default "<div class=\"overlay is-open overlay--light\">\n  Rerouting...\n</div>";